export const getRangeText = (
  rangeStart: number,
  rangeEnd: number | null,
  totalCount: number
): string => {
  const hasStart = rangeStart !== null && rangeStart !== undefined;
  const hasEnd = rangeEnd !== null && rangeEnd !== undefined;

  if (hasStart && hasEnd) {
    if (rangeStart === 0 && rangeEnd === 0) {
      return `Showing 0 of ${totalCount}`;
    }
    return `Showing ${rangeStart}-${rangeEnd} of ${totalCount}`;
  } else if (hasStart) {
    return `Showing ${rangeStart} of ${totalCount}`;
  } else if (hasEnd) {
    return `Showing ${rangeEnd} of ${totalCount}`;
  } else {
    return `Showing 0 of ${totalCount}`;
  }
};
